import { render, staticRenderFns } from "./TagInputManager.ts.vue?vue&type=template&id=198b1ace"
import script from "./TagInputManager.ts.vue?vue&type=script&setup=true&lang=ts"
export * from "./TagInputManager.ts.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TagInputManager.ts.vue?vue&type=style&index=0&id=198b1ace&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports